import { CLIENT_ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment/client';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { environment } from '../../environments/environment';

export const provideClientEnvironment = () => [
  { provide: ENVIRONMENT_PROVIDER, useValue: environment },
  { provide: CLIENT_ENVIRONMENT_PROVIDER, useValue: environment },
];
